import "./Products.css";
import React from "react";
import MobxView from "higher-order/MobxView";
import MarketingPageContent from "../components/MarketingPageContent";
import MarketingHero from "../components/MarketingHero";
import CustomizeBenefits from "../components/CustomizeBenefits";
import ContentItem from "shared/components/cms/ContentItem";
import ProductStore from "../models/ProductStore";
import MarketingProductNavbar from "../components/MarketingProductNavbar";
import { renderMarketingTestimonial } from "../components/MarketingVideoHelpers";
import Propulator from "../../higher-order/Propulator";
import OnboardingCard from "../components/products/OnboardingCard";
import BulletPoint from "../components/BulletPoint";
import map from "lodash/map";
import { URLS } from "util/constants";
import { ANDERSEN_TAX_VIDEO_KEY } from "../models/HomeStore";

const SOLUTIONS_BULLET_KEYS = [
    "suiteSolutionBullet1",
    "suiteSolutionBullet2",
    "suiteSolutionBullet3"
];

const PRODUCT_CARDS = [
    {
        className: "fincore",
        title: <React.Fragment>FINANCIAL <span className="highlighted">Core</span></React.Fragment>,
        bodyText: <React.Fragment>Give employees access to a financial wellness platform that can help them <span className="highlighted">take control of their financial well-being.</span></React.Fragment>,
        image: require("../assets/redesign2020/products/fincore-lifestyle.png"),
        imageAlt: "Financial Core",
        productHref: URLS.MARKETING.REFI,
        bulletContentKeys: [
            "fincoreBullet1",
            "fincoreBullet2",
            "fincoreBullet3"
        ]
    },
    {
        className: "slp",
        title: <React.Fragment>STUDENT LOAN <span className="highlighted">PayDown</span></React.Fragment>,
        bodyText: <React.Fragment>Help your employees <span className="highlighted">pay down their student loan debt faster</span> through direct contributions towards their student loans so they can focus on their next financial goal.</React.Fragment>,
        image: require("../assets/redesign2020/products/slp-lifestyle.png"),
        imageAlt: "Student Loan Paydown",
        productHref: URLS.MARKETING.PAYDOWN,
        bulletContentKeys: [
            "slpBullet1",
            "slpBullet2",
            "slpBullet3"
        ]
    },
    {
        className: "csu",
        title: <React.Fragment>COLLEGE <span className="highlighted">SaveUp</span></React.Fragment>,
        bodyText: <React.Fragment>Help your employees <span className="highlighted">save for their children's education</span> with direct contributions to their 529 college savings plans.</React.Fragment>,
        image: require("../assets/redesign2020/products/csu-lifestyle.png"),
        imageAlt: "College Save Up",
        productHref: URLS.MARKETING.SAVEUP,
        bulletContentKeys: [
            "csuBullet1",
            "csuBullet2",
            "csuBullet3"
        ]
    }
];

const ENROLLMENT_BULLET_KEYS = [
    "enrollmentBullet1",
    "enrollmentBullet2",
    "enrollmentBullet3",
    "enrollmentBullet4"
];

const LEGAL_TEXT_KEYS = [
    "legalText1"
];

const PRODUCT_NAVBAR_DESKTOP_DISTANCE = 665;
const PRODUCT_NAVBAR_TABLET_DISTANCE = 406;

class Products extends React.Component {
    render() {
        return (
            <MarketingPageContent enableSubfooter={true} legalTextKeys={LEGAL_TEXT_KEYS}>
                <div className="marketing-products">
                    <div className="hero-wrapper">
                        <img alt={"background"} className="background-triangle" src={require("../assets/redesign2020/products/background-triangle.svg")} />
                        <MarketingHero
                            desktopImage={require("../assets/redesign2020/products/desktop-hero.png")}
                            tabletImage={require("../assets/redesign2020/products/tablet-hero.png")}
                            mobileImage={require("../assets/redesign2020/products/mobile-hero.png")}
                            containsChevron={true}
                        >
                            <span>Financial </span>
                            <span>wellness </span>
                            <span className="benefits">benefits </span>
                            <span className="highlighted">that </span>
                            <span className="highlighted works">work for all<span className="period">.</span></span>
                            <span className="subtitle">Our solutions meet your employees where they are, to help get them where they want to be.</span>
                        </MarketingHero>
                    </div>
                    <MarketingProductNavbar tabletTop={PRODUCT_NAVBAR_TABLET_DISTANCE} desktopTop={PRODUCT_NAVBAR_DESKTOP_DISTANCE} />
                    <div className="suite-solutions">
                        <h1 className="solutions-header">Gradifi <br /><span className="highlighted">Suite of Solutions</span></h1>
                        <div className="solutions-body">
                            <div className="solutions-body-text-wrapper">
                                <ContentItem tag="p" contentKey="suiteSolutionBody" className="solutions-body-text" />
                            </div>
                            <div className="solutions-list-wrapper">
                                <ContentItem tag="div" contentKey="suiteSolutionListTitle" className="solutions-list-title" />
                                <ul className="solutions-list">
                                    {map(SOLUTIONS_BULLET_KEYS, (contentKey) => (
                                        <BulletPoint
                                            key={contentKey}
                                            contentKey={contentKey}
                                            className={"solutions-list-item"}
                                        />
                                    ))
                                    }
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="product-cards">
                        {map(PRODUCT_CARDS, ({ className, title, image, imageAlt, bodyText, bulletContentKeys, productHref }) => (
                            <div className={className} key={className}>
                                <div className="product-image-wrapper">
                                    <img className="product-image" alt={imageAlt} src={image} />
                                </div>
                                <div className="product-body">
                                    <h2 className="product-header">{title}</h2>
                                    <h3 className="product-body-text">{bodyText}</h3>
                                    <ul className="product-list">
                                        {map(bulletContentKeys, (contentKey) => (
                                            <BulletPoint
                                                key={contentKey}
                                                contentKey={contentKey}
                                                className="product-list-text"
                                                superScript={contentKey === "slpBullet1" ? "legal-text-1" : ""}
                                            />
                                        ))}
                                    </ul>
                                </div>
                                <a href={productHref} className="button">LEARN MORE</a>
                            </div>
                        ))}
                    </div>
                    <CustomizeBenefits />
                    <div className="onboard-security">
                        <img className="onboard-security-background" aria-hidden="true" alt="" src={require("../assets/redesign2020/products/onboarding-background.svg")} />
                        <OnboardingCard />
                        <div className="security-card">
                            <img src={require("../assets/redesign2020/products/security.png")} alt="Security is at the heart of our platform" className="security-image" />
                            <h2 className="security-header">Security is <span className="highlighted">the heart of our platform</span>.</h2>
                            <ContentItem tag="p" contentKey="securitySummary" className="security-body" />
                        </div>
                    </div>
                    <div className="enrollment">
                        <img src={require("../assets/redesign2020/products/enrollment-triangle.svg")} className="enrollment-background-image" alt="" />
                        <div className="enrollment-wrapper">
                            <div className="enrollment-image-wrapper">
                                <img src={require("../assets/redesign2020/products/enrollment.png")} className="enrollment-image" alt="Enrollment is just the beginning" />
                            </div>
                            <div className="enrollment-body">
                                <h2 className="enrollment-header">Enrollment is <span className="highlighted">just the beginning</span>.</h2>
                                <ContentItem tag="p" contentKey="enrollmentBodyText" className="enrollment-body-text" />
                                <ul className="enrollment-list">
                                    {map(ENROLLMENT_BULLET_KEYS, (bulletKey) => (
                                        <BulletPoint
                                            key={bulletKey}
                                            contentKey={bulletKey}
                                            className={"enrollment-list-item"}
                                        />
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                    {renderMarketingTestimonial(this.props.videoModals[ANDERSEN_TAX_VIDEO_KEY])}
                </div>
            </MarketingPageContent>
        );
    }
}

const propulateView = Propulator(Products, {
    productStore: ["videoModals"]
});

export default MobxView(propulateView, {
    ProductStore
});
